import FormattedText from "../../../FormattedText/FormattedText";
import type { BulkBookingPersuasionData } from "../../CommonLandingMweb.types";
import {
  CardDescription,
  CardTitle,
  GraphicCol,
  GraphicShadow,
  HeaderIcon,
  HeaderRow,
  HeaderTitle,
  PersuasionCard,
  Section,
  TextCol,
} from "./Styles";

export const BulkBookingPersuasion = ({
  data,
}: {
  data?: BulkBookingPersuasionData;
}) => {
  if (!data) return null;

  const { header, card } = data;
  const title = card?.title;
  const description = card?.description;
  const imageUrl = card?.image?.trim();
  const headerTitle = header?.title;
  const headerIcon = header?.icon?.trim();

  const hasHeader =
    (typeof headerTitle === "string" && headerTitle.length > 0) ||
    (headerTitle != null && typeof headerTitle === "object");

  if (
    !hasHeader &&
    title == null &&
    description == null &&
    !imageUrl
  ) {
    return null;
  }

  return (
    <Section aria-label={typeof headerTitle === "string" ? headerTitle : undefined}>
      {hasHeader ? (
        <HeaderRow>
          {headerIcon ? <HeaderIcon src={headerIcon} alt="" /> : null}
          <HeaderTitle>
            <FormattedText value={headerTitle} />
          </HeaderTitle>
        </HeaderRow>
      ) : null}

      <PersuasionCard>
        <TextCol>
          {title != null ? (
            <CardTitle>
              <FormattedText value={title} />
            </CardTitle>
          ) : null}
          {description != null ? (
            <CardDescription>
              <FormattedText value={description} />
            </CardDescription>
          ) : null}
        </TextCol>
        {imageUrl ? (
          <GraphicCol>
            <GraphicShadow aria-hidden />
            <img src={imageUrl} alt="" />
          </GraphicCol>
        ) : null}
      </PersuasionCard>
    </Section>
  );
};
